module.exports = __webpack_public_path__ + "static/media/delete-tool-dark.24933d04.svg";